import styled from 'styled-components';
import { failure, screenXsMax } from '@spotify-internal/encore-foundation';
export default styled.abbr.withConfig({
  displayName: "Required",
  componentId: "sc-1ai3yue-0"
})(["color:", ";@media (max-width:", "){flex:1;}"], failure, screenXsMax);